module.exports = __webpack_public_path__ + "static/assets/11b6b2c59badc77e9e4749c2fcfe4bb0.png";